const sidebarInitialState = {
  isGratitudeModalOpen: false,
  sidebar:              null,
  show:                 false,
  title:                '',
};

export default sidebarInitialState;
